import tw, { css, TwStyle } from 'twin.macro'

const SectionStyle = (overWrite?: TwStyle) =>
  css(tw`lg:mt-32 mt-16`, overWrite && overWrite)

export default SectionStyle
